import BaseApi from '../base/apiBase.service';

export default class ExamManagementService extends BaseApi {
  constructor(args) {
    super(args);

    this.serviceEndpoints = {
      baseUrl: process.env.REACT_APP_BACKEND_URL,
      get: '/api/exam',
      create: '/api/exam',
      update: '/api/exam',
      delete: '/api/exam',
    };
  }
  async getByParameters(data) {
    return super.getByParameters(data);
  }

  async update(data) {
    return super.update(data);
  }

  async create(data) {
    return super.create(data);
  }

  async delete(data) {
    return super.delete(data);
  }
  
  async get(payload) {
    return super.get(payload, this.serviceEndpoints.get);
  }
}
